import React, { useEffect } from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMListingPageValuation } from "../../components/CRMListingPageValuation/CRMListingPageValuation";
import { Background } from "../../components/BuildingBlocks/Background";
import { Text } from "../../components/BuildingBlocks/Text";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMColors } from "../../models/CRMColors";

export const CRMListingPageValuationContainer = (props: TContainerStateProps): JSX.Element => {
    const listingId = props.state.routes.params.listingId;

    useEffect(
        () => {
            props.dispatch({ type: "LISTING_PAGE_GET_VALUATION_TAB", payload: listingId });
        },
        [listingId],
    );

    const valuationForm = props.state.forms.listing_page.valuation_tab;

    return (
        valuationForm.status === "loading"
            ? <Background padding={`${CRMSpacing.LARGE} ${CRMSpacing.LARGE}`}>
                <Text color={CRMColors.NEUTRAL_4}>Loading valuation…</Text>
            </Background>
            : valuationForm.status === "failure"
                ? <Background padding={`${CRMSpacing.LARGE} ${CRMSpacing.LARGE}`}>
                    <Text color={CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_0}>
                        Couldn't load the valuation. Reload the page to try again.
                    </Text>
                </Background>
                : <CRMListingPageValuation
                output={valuationForm.output}
                listingId={listingId}
                listingPageData={props.state.forms.listing_page.data}
                onListingChange={(form) => props.dispatch({
                    type: "LISTING_PREPARATION_FORM_CHANGE",
                    payload: form,
                })}
                actionForm={props.state.forms.listing_page.valuation_action}
                isSubmitting={props.state.forms.listing_page.valuation_action.status === "submitting"}
                onAction={(action, extra) => props.dispatch({
                    type: "LISTING_PAGE_VALUATION_ACTION",
                    payload: {
                        listing_id: listingId,
                        action,
                        amend_price_pence: null,
                        amend_reason: null,
                        fact_field: null,
                        ...extra,
                    },
                })}
            />
    );
};
